export const all = ['tripDetails'] as const
export const check = (text: string) => [...all, 'check', text] as const
